module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAABLElEQVRIx2NgcFpGKzQcjRYNWgtheFbsR2PApUgzWip0PZB0K9u3/8JLm7zdYU1Hfv7+a5u/G4iADCAXKAiUAiqAKybKaKDOUzfeGmfs0EvZtmzvA6BOxahNFjm7xILWARGQAeQCBYFSQAVAZUDFQC1EGQ3UPG3jLT6f1YzOIC6ERENwKaAyoGKgFoqikdtjPk1SCK/n3Fu7JdKrk0X8ZlLZaLuUuldH+L6cZF8+35KaRuvFdBxdrwY0F4g+neBo6gqkjtGNnUF394hBzIWgpwcEF862M09optRo2+Q6ZHMh6MNxLvXwHioEyMzpTmhGd/f5UCesGZ2XdvX7AE18fkhg81LDqVNdtCO7qJZCtKK6dq/SEfSexeG2kM9rDjUTn3zwpObuwNHymhIEAAQlWvnO7P8jAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/ks.png
// module id = 318
// module chunks = 0